import VForm from '@/vuetify_custom/v-form'
import { commonValidateRule } from '../utils'
import {common_mixins} from './EditMixIns.jsx'
const commonValidateRuleGo = commonValidateRule('必选')
export default {
    mixins:[common_mixins],
    props: {
        defaultApply: {
            type: Array,
        }
    },
    computed: {
        fields() {
            const _this = this
            return [
                {
                    label: '填表时间',
                    key:'zhibiao_date',
                    cols: 3,
                    disabled: true
                },
                {
                    label: '申请人',
                    key:'apply_user_id',
                    initList: this.defaultApply,
                    out_params: {
                        formal: true,
                    },
                    type:'autocompletes_async_v1',
                    'item-value':'id',
                    'item-text':'account',
                    api: this.$util.api.customer_select_search,
                    init_list: [], // this.apply_user_list,
                    cols: 2,
                    required: true,
                    disabled: this.is_generate_from_contract_child,
                    rules: [commonValidateRuleGo],
                    handle_data:({customers}) => {
                     return customers
                    },
                    change:(data, target = {}) => {
                        _this.params.apply_user = target.account
                        if (!_this.params.id) {
                            _this.params.principal = target.account
                        }
                    }
                },
                {
                    label: '制单人',
                    key:'fill_user',
                    cols: 2,
                    disabled: true,
                },
                {
                    label: '负责人',
                    key:'principal',
                    cols: 2,
                    disabled: true,
                },
                {
                    label: '编号（保存后自动生成）',
                    type: 'text_field',
                    key: 'uid',
                    cols: 3,
                    disabled: true,
                  }
            ]
        }
    },
    render() {
        const _this = this
        return <VForm
            ref="base"
            fields={_this.fields}
            v-model={_this.params}
        />
    }
}